import { AdminCatalogModel } from 'src/app/model/admin/catalog';
import { BaseModalModel } from 'src/app/model/core/base-modal';

export interface AdminCatalogState {
  result: AdminCatalogModel[];
  subCatalogs: { [key: string]: AdminCatalogModel[] };
  modal: BaseModalModel<AdminCatalogModel>;
}

export const adminCatalogIS: AdminCatalogState = {
  result: [],
  subCatalogs: {
    'doc_type': [],
    'gender': [],
    'mar_status': [],
    'spe': [],
    'turn_status': [],
  },
  modal: {
    isVisible: false,
    title: '',
    value: {},
  },
};
